import { TypeInput, TypeStep } from './automations-models';
import { IntegrationType } from './integrations-models';

export enum ACTIONS_TYPES {
  ApsisAddEmailToList = 'Triggerbee.Automations.Client.Automations.Models.Actions.Apsis.ApsisAddEmailToListAutomationActionApiModel, Triggerbee.Automations.Client',
  ApsisOneAddToSubscription = 'Triggerbee.Automations.Client.Automations.Models.Actions.ApsisOne.ApsisOneAddToSubscriptionAutomationActionApiModel, Triggerbee.Automations.Client',
  ApsisOneCreateSubscriber = 'Triggerbee.Automations.Client.Automations.Models.Actions.ApsisOne.ApsisOneCreateSubscriberAutomationActionApiModel, Triggerbee.Automations.Client',
  ApsisOneUpdateField = 'Triggerbee.Automations.Client.Automations.Models.Actions.ApsisOne.ApsisOneUpdateFieldAutomationActionApiModel, Triggerbee.Automations.Client',
  ApsisSendMail = 'Triggerbee.Automations.Client.Automations.Models.Actions.Apsis.ApsisSendMailAutomationActionApiModel, Triggerbee.Automations.Client',
  ApsisUpdateMergeTag = 'Triggerbee.Automations.Client.Automations.Models.Actions.Apsis.ApsisUpdateMergeTagAutomationActionApiModel, Triggerbee.Automations.Client',
  BrevoCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Brevo.BrevoCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  BrevoUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Brevo.BrevoUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  CentraCreateMember = 'Triggerbee.Automations.Client.Automations.Models.Actions.Centra.CentraCreateMemberAutomationActionApiModel, Triggerbee.Automations.Client',
  CleverReachCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.CleverReach.CleverReachCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  CleverReachUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.CleverReach.CleverReachUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  CustobarAddEmailToList = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custobar.CustobarAddEmailToListAutomationActionApiModel, Triggerbee.Automations.Client',
  CustobarAddTagsToSubscriber = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custobar.CustobarAddTagsToSubscriberAutomationActionApiModel, Triggerbee.Automations.Client',
  CustobarRemoveTagsFromSubscriber = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custobar.CustobarRemoveTagsFromSubscriberAutomationActionApiModel, Triggerbee.Automations.Client',
  CustobarTrigger = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custobar.CustobarTriggerAutomationAutomationActionApiModel, Triggerbee.Automations.Client',
  CustobarUpdateField = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custobar.CustobarUpdateFieldAutomationActionApiModel, Triggerbee.Automations.Client',
  CustobarUpdateSubscriberLists = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custobar.CustobarUpdateSubscriberListsAutomationActionApiModel, Triggerbee.Automations.Client',
  CustomSendWebhook = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custom.CustomSendWebhookAutomationActionApiModel, Triggerbee.Automations.Client',
  DotdigitalCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Dotdigital.DotdigitalCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  DotdigitalUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Dotdigital.DotdigitalUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  EmarsysAddEmailToList = 'Triggerbee.Automations.Client.Automations.Models.Actions.Emarsys.EmarsysAddEmailToListAutomationActionApiModel, Triggerbee.Automations.Client',
  EmarsysTrigger = 'Triggerbee.Automations.Client.Automations.Models.Actions.Emarsys.EmarsysTriggerAutomationAutomationActionApiModel, Triggerbee.Automations.Client',
  EmarsysUpdateField = 'Triggerbee.Automations.Client.Automations.Models.Actions.Emarsys.EmarsysUpdateFieldAutomationActionApiModel, Triggerbee.Automations.Client',
  KlaviyoAddEmailToList = 'Triggerbee.Automations.Client.Automations.Models.Actions.Klaviyo.KlaviyoAddEmailToListAutomationActionApiModel, Triggerbee.Automations.Client',
  KlaviyoUpdateField = 'Triggerbee.Automations.Client.Automations.Models.Actions.Klaviyo.KlaviyoUpdateFieldAutomationActionApiModel, Triggerbee.Automations.Client',
  KlaviyoUpdateSubscriberLists = 'Triggerbee.Automations.Client.Automations.Models.Actions.Klaviyo.KlaviyoUpdateSubscriberListsAutomationActionApiModel, Triggerbee.Automations.Client',
  MailchimpAddEmailToList = 'Triggerbee.Automations.Client.Automations.Models.Actions.Mailchimp.MailchimpAddEmailToListAutomationActionApiModel, Triggerbee.Automations.Client',
  MailchimpAddTagsToSubscriber = 'Triggerbee.Automations.Client.Automations.Models.Actions.Mailchimp.MailchimpAddTagsToSubscriberAutomationActionApiModel, Triggerbee.Automations.Client',
  MailchimpRemoveTagsFromSubscriber = 'Triggerbee.Automations.Client.Automations.Models.Actions.Mailchimp.MailchimpRemoveTagsFromSubscriberAutomationActionApiModel, Triggerbee.Automations.Client',
  MailchimpUpdateMergeTag = 'Triggerbee.Automations.Client.Automations.Models.Actions.Mailchimp.MailchimpUpdateMergeTagAutomationActionApiModel, Triggerbee.Automations.Client',
  MailerLiteAddEmailToList = 'Triggerbee.Automations.Client.Automations.Models.Actions.MailerLite.MailerLiteAddEmailToListAutomationActionApiModel, Triggerbee.Automations.Client',
  MailerLiteUpdateField = 'Triggerbee.Automations.Client.Automations.Models.Actions.MailerLite.MailerLiteUpdateFieldAutomationActionApiModel, Triggerbee.Automations.Client',
  MailerSendSendEmail = 'Triggerbee.Automations.Client.Automations.Models.Actions.MailerSend.MailerSendSendEmailAutomationActionApiModel, Triggerbee.Automations.Client',
  OmnisendCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Omnisend.OmnisendCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  OmnisendUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Omnisend.OmnisendUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  PipedriveCreateDeal = 'Triggerbee.Automations.Client.Automations.Models.Actions.Pipedrive.PipedriveCreateDealAutomationActionApiModel, Triggerbee.Automations.Client',
  PipedriveCreateNote = 'Triggerbee.Automations.Client.Automations.Models.Actions.Pipedrive.PipedriveCreateNoteAutomationActionApiModel, Triggerbee.Automations.Client',
  PipedriveCreateOrUpdatePersonOrganization = 'Triggerbee.Automations.Client.Automations.Models.Actions.Pipedrive.PipedriveCreateOrUpdatePersonOrganizationAutomationActionApiModel, Triggerbee.Automations.Client',
  PipedriveUpdateDeal = 'Triggerbee.Automations.Client.Automations.Models.Actions.Pipedrive.PipedriveUpdateDealAutomationActionApiModel, Triggerbee.Automations.Client',
  RuleMailerAddTagToSubscriber = 'Triggerbee.Automations.Client.Automations.Models.Actions.RuleMailer.RuleMailerAddTagToSubscriberAutomationActionApiModel, Triggerbee.Automations.Client',
  RuleMailerRemoveTagFromSubscriber = 'Triggerbee.Automations.Client.Automations.Models.Actions.RuleMailer.RuleMailerRemoveTagFromSubscriberAutomationActionApiModel, Triggerbee.Automations.Client',
  RuleMailerUpdateMergeTag = 'Triggerbee.Automations.Client.Automations.Models.Actions.RuleMailer.RuleMailerUpdateMergeTagAutomationActionApiModel, Triggerbee.Automations.Client',
  RuleUpdateSubscriberTags = 'Triggerbee.Automations.Client.Automations.Models.Actions.RuleMailer.RuleUpdateSubscriberTagsAutomationActionApiModel, Triggerbee.Automations.Client',
  ShopifyCreateMember = 'Triggerbee.Automations.Client.Automations.Models.Actions.Shopify.ShopifyCreateMemberAutomationActionApiModel, Triggerbee.Automations.Client',
  ShopwareCreateMember = 'Triggerbee.Automations.Client.Automations.Models.Actions.Shopware.ShopwareCreateMemberAutomationActionApiModel, Triggerbee.Automations.Client',
  TriggerbeeAddTag = 'Triggerbee.Automations.Client.Automations.Models.Actions.Triggerbee.TriggerbeeAddTagAutomationActionApiModel, Triggerbee.Automations.Client',
  TriggerbeeCartAbandonment = 'Triggerbee.Automations.Client.Automations.Models.Actions.Triggerbee.TriggerbeeCartAbandonmentAutomationActionApiModel, Triggerbee.Automations.Client',
  TriggerbeeExecuteWebhook = 'Triggerbee.Automations.Client.Automations.Models.Actions.Triggerbee.TriggerbeeExecuteWebhookAutomationActionApiModel, Triggerbee.Automations.Client',
  TriggerbeeRemoveTag = 'Triggerbee.Automations.Client.Automations.Models.Actions.Triggerbee.TriggerbeeRemoveTagAutomationActionApiModel, Triggerbee.Automations.Client',
  TriggerbeeSendMail = 'Triggerbee.Automations.Client.Automations.Models.Actions.Triggerbee.TriggerbeeSendMailAutomationActionApiModel, Triggerbee.Automations.Client',
  TriggerbeeTransactionEmail = 'Triggerbee.Automations.Client.Automations.Models.Actions.Triggerbee.TriggerbeeTransactionEmailAutomationActionApiModel, Triggerbee.Automations.Client',
  TriggerbeeWait = 'Triggerbee.Automations.Client.Automations.Models.Actions.Triggerbee.TriggerbeeWaitAutomationActionApiModel, Triggerbee.Automations.Client',
  VoyadoAddEmailToList = 'Triggerbee.Automations.Client.Automations.Models.Actions.Voyado.VoyadoAddEmailToListAutomationActionApiModel, Triggerbee.Automations.Client',
  VoyadoRegisterCart = 'Triggerbee.Automations.Client.Automations.Models.Actions.Voyado.VoyadoRegisterCartAutomationActionApiModel, Triggerbee.Automations.Client',
  VoyadoTrigger = 'Triggerbee.Automations.Client.Automations.Models.Actions.Voyado.VoyadoTriggerAutomationAutomationActionApiModel, Triggerbee.Automations.Client',
  VoyadoUpdateConsentPreferences = 'Triggerbee.Automations.Client.Automations.Models.Actions.Voyado.VoyadoUpdateConsentPreferencesAutomationActionApiModel, Triggerbee.Automations.Client',
  VoyadoUpdateMergeTag = 'Triggerbee.Automations.Client.Automations.Models.Actions.Voyado.VoyadoUpdateMergeTagAutomationActionApiModel, Triggerbee.Automations.Client',
  ZapierTriggerZap = 'Triggerbee.Automations.Client.Automations.Models.Actions.Zapier.ZapierTriggerZapAutomationActionApiModel, Triggerbee.Automations.Client',
}

export enum ACTIONS_TYPES_REAL_TIME {
  BrevoCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Brevo.BrevoCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  BrevoUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Brevo.BrevoUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  CentraCreateMember = 'Triggerbee.Automations.Client.Automations.Models.Actions.Centra.CentraCreateMemberAutomationActionApiModel, Triggerbee.Automations.Client',
  CleverReachCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.CleverReach.CleverReachCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  CleverReachUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.CleverReach.CleverReachUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  CustobarUpdateSubscriberLists = 'Triggerbee.Automations.Client.Automations.Models.Actions.Custobar.CustobarUpdateSubscriberListsAutomationActionApiModel, Triggerbee.Automations.Client',
  DotdigitalCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Dotdigital.DotdigitalCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  DotdigitalUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Dotdigital.DotdigitalUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  KlaviyoUpdateSubscriberLists = 'Triggerbee.Automations.Client.Automations.Models.Actions.Klaviyo.KlaviyoUpdateSubscriberListsAutomationActionApiModel, Triggerbee.Automations.Client',
  OmnisendCreateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Omnisend.OmnisendCreateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  OmnisendUpdateContact = 'Triggerbee.Automations.Client.Automations.Models.Actions.Omnisend.OmnisendUpdateContactAutomationActionApiModel, Triggerbee.Automations.Client',
  RuleUpdateSubscriberTags = 'Triggerbee.Automations.Client.Automations.Models.Actions.RuleMailer.RuleUpdateSubscriberTagsAutomationActionApiModel, Triggerbee.Automations.Client',
  ShopifyCreateMember = 'Triggerbee.Automations.Client.Automations.Models.Actions.Shopify.ShopifyCreateMemberAutomationActionApiModel, Triggerbee.Automations.Client',
  ShopwareCreateMember = 'Triggerbee.Automations.Client.Automations.Models.Actions.Shopware.ShopwareCreateMemberAutomationActionApiModel, Triggerbee.Automations.Client',
}

export const ActionRealTimeRegistrationType = [
  ACTIONS_TYPES_REAL_TIME.CentraCreateMember,
  ACTIONS_TYPES_REAL_TIME.ShopifyCreateMember,
];

export const ActionRealTimeScl = [
  ACTIONS_TYPES_REAL_TIME.CustobarUpdateSubscriberLists,
  ACTIONS_TYPES_REAL_TIME.KlaviyoUpdateSubscriberLists,
  ACTIONS_TYPES_REAL_TIME.RuleUpdateSubscriberTags,
  //TODO: Fix Brevo SCL. ACTIONS_TYPES.BrevoCreateContact,
];

export const ActionWithRealTime = [
  ACTIONS_TYPES.BrevoCreateContact,
  ACTIONS_TYPES.CleverReachCreateContact,
  ACTIONS_TYPES.CustobarAddEmailToList,
  ACTIONS_TYPES.DotdigitalCreateContact,
  ACTIONS_TYPES.KlaviyoAddEmailToList,
  ACTIONS_TYPES.OmnisendCreateContact,
  ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
  ACTIONS_TYPES.ShopwareCreateMember,
  ACTIONS_TYPES.VoyadoAddEmailToList,
];

export const ActionWithRealTimeScl = [
  ACTIONS_TYPES.CustobarAddEmailToList,
  ACTIONS_TYPES.KlaviyoAddEmailToList,
  ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
  //TODO: Fix Brevo SCL. ACTIONS_TYPES.BrevoCreateContact,
];

export const UpdateRealTimeActions = [
  ACTIONS_TYPES.BrevoUpdateContact,
  ACTIONS_TYPES.CleverReachUpdateContact,
  ACTIONS_TYPES.DotdigitalUpdateContact,
  ACTIONS_TYPES.OmnisendUpdateContact,
  ACTIONS_TYPES.VoyadoUpdateMergeTag,
  ACTIONS_TYPES.RuleMailerUpdateMergeTag,
];

export const CreateRealTimeActions = [
  ACTIONS_TYPES.BrevoCreateContact,
  ACTIONS_TYPES.CleverReachCreateContact,
  ACTIONS_TYPES.DotdigitalCreateContact,
  ACTIONS_TYPES.OmnisendCreateContact,
  ACTIONS_TYPES.VoyadoAddEmailToList,
  ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
];

// Integrations whose create action is always real-time (no opt-in), so their field mapping excludes inputs
// that can't be mapped live (telephone / social-security).
export const ALWAYS_REAL_TIME_APPS: ReadonlyArray<string> = [
  IntegrationType.Brevo,
  IntegrationType.CleverReach,
  IntegrationType.Dotdigital,
  IntegrationType.Omnisend,
];

export const REAL_TIME_HANDLER_TYPE =
  'Triggerbee.Widgets.Client.FormSettings.WidgetFormSubmitResultApiModel, Triggerbee.Widgets.Client';

export const ACTIONS = [
  {
    $type: ACTIONS_TYPES.ApsisAddEmailToList,
    properties: ['listId'],
  },
  {
    $type: ACTIONS_TYPES.ApsisOneAddToSubscription,
    properties: ['channelDiscriminator', 'topicDiscriminator', 'type', 'reason', 'source'],
  },
  {
    $type: ACTIONS_TYPES.ApsisOneCreateSubscriber,
    properties: [],
  },
  {
    $type: ACTIONS_TYPES.ApsisOneUpdateField,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.ApsisSendMail,
    properties: ['projectId'],
  },
  {
    $type: ACTIONS_TYPES.ApsisUpdateMergeTag,
    properties: ['fieldName', 'fieldValue', 'listId'], //property listId was removed
  },
  {
    $type: ACTIONS_TYPES.BrevoCreateContact,
    properties: ['listIds'],
  },
  {
    $type: ACTIONS_TYPES.BrevoUpdateContact,
    properties: ['fieldName', 'fieldValue', 'listIds'],
  },
  {
    $type: ACTIONS_TYPES.CentraCreateMember,
    properties: ['isRunningInRealTime'],
  },
  {
    $type: ACTIONS_TYPES.CleverReachCreateContact,
    properties: ['doubleOptInFormId', 'fieldMappings'],
  },
  {
    $type: ACTIONS_TYPES.CleverReachUpdateContact,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.CustobarAddEmailToList,
    properties: ['listId'],
  },
  {
    $type: ACTIONS_TYPES.CustobarAddTagsToSubscriber,
    properties: ['tags'],
  },
  {
    $type: ACTIONS_TYPES.CustobarRemoveTagsFromSubscriber,
    properties: ['tags'],
  },
  {
    $type: ACTIONS_TYPES.CustobarTrigger,
    properties: ['eventName'],
  },
  {
    $type: ACTIONS_TYPES.CustobarUpdateField,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.CustobarUpdateSubscriberLists,
    properties: ['isRunningInRealTime'],
  },
  {
    $type: ACTIONS_TYPES.CustomSendWebhook,
    properties: ['webhookUrl', 'webhookHttpMethod', 'webhookFieldMappings'],
  },
  {
    $type: ACTIONS_TYPES.DotdigitalCreateContact,
    properties: ['lists', 'updateIfExists'],
  },
  {
    $type: ACTIONS_TYPES.DotdigitalUpdateContact,
    properties: ['fieldName', 'fieldValue', 'lists'],
  },
  {
    $type: ACTIONS_TYPES.EmarsysAddEmailToList,
    properties: ['listId'],
  },
  {
    $type: ACTIONS_TYPES.EmarsysTrigger,
    properties: ['eventId'],
  },
  {
    $type: ACTIONS_TYPES.EmarsysUpdateField,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.KlaviyoAddEmailToList,
    properties: ['listId'],
  },
  {
    $type: ACTIONS_TYPES.KlaviyoUpdateField,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.KlaviyoUpdateSubscriberLists,
    properties: ['isRunningInRealTime'],
  },
  {
    $type: ACTIONS_TYPES.MailchimpAddEmailToList,
    properties: ['listId', 'enableDoubleOptIn'],
  },
  {
    $type: ACTIONS_TYPES.MailchimpAddTagsToSubscriber,
    properties: ['tags', 'listId'], //property listId was removed
  },
  {
    $type: ACTIONS_TYPES.MailchimpRemoveTagsFromSubscriber,
    properties: ['tags', 'listId'], //property listId was removed
  },
  {
    $type: ACTIONS_TYPES.MailchimpUpdateMergeTag,
    properties: ['fieldName', 'fieldValue', 'listId'], //property listId was removed
  },
  {
    $type: ACTIONS_TYPES.MailerLiteAddEmailToList,
    properties: ['listId'],
  },
  {
    $type: ACTIONS_TYPES.MailerLiteUpdateField,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.MailerSendSendEmail,
    properties: ['templateId'],
  },
  {
    $type: ACTIONS_TYPES.OmnisendCreateContact,
    properties: ['tags', 'updateIfExists'],
  },
  {
    $type: ACTIONS_TYPES.OmnisendUpdateContact,
    properties: ['fieldName', 'fieldValue'],
  },

  {
    $type: ACTIONS_TYPES.PipedriveCreateDeal,
    properties: ['userId', 'insertIfNoMatch', 'noteContent', 'dealValue', 'dealStatus', 'pipelineAndStagingIds'],
  },
  {
    $type: ACTIONS_TYPES.PipedriveCreateNote,
    properties: ['userId', 'noteContent', 'insertIfNoMatch'],
  },
  {
    $type: ACTIONS_TYPES.PipedriveCreateOrUpdatePersonOrganization,
    properties: ['insertIfNoMatch', 'userId'],
  },
  {
    $type: ACTIONS_TYPES.PipedriveUpdateDeal,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
    properties: ['tagIds', 'doubleOptIn', 'language', 'forceSubscribing', 'resetAutomation', 'isRunningInRealTime'],
  },
  {
    $type: ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber,
    properties: ['tagId'],
  },
  {
    $type: ACTIONS_TYPES.RuleMailerUpdateMergeTag,
    properties: ['fieldName', 'fieldValue', 'tagIds'], //property tagId was removed
  },
  {
    $type: ACTIONS_TYPES.RuleUpdateSubscriberTags,
    properties: ['isRunningInRealTime'],
  },
  {
    $type: ACTIONS_TYPES.ShopifyCreateMember,
    properties: ['isRunningInRealTime'],
  },
  {
    $type: ACTIONS_TYPES.ShopwareCreateMember,
    properties: ['isRunningInRealTime', 'salesChannelId', 'groupId', 'defaultPaymentMethodId', 'countryId'],
  },
  {
    $type: ACTIONS_TYPES.TriggerbeeAddTag,
    properties: ['tag', 'addToProfile'],
  },
  {
    $type: ACTIONS_TYPES.TriggerbeeCartAbandonment,
    properties: ['cartGoalArgument', 'purchaseGoalArgument', 'minutes'],
  },
  {
    $type: ACTIONS_TYPES.TriggerbeeExecuteWebhook,
    properties: ['url', 'useNewPayloadFormat'],
  },
  {
    $type: ACTIONS_TYPES.TriggerbeeRemoveTag,
    properties: ['tag', 'removeFromProfile'],
  },
  {
    $type: ACTIONS_TYPES.TriggerbeeSendMail,
    properties: ['recipients', 'subject', 'message', 'replyTo'],
  },
  {
    $type: ACTIONS_TYPES.TriggerbeeTransactionEmail,
    properties: ['templateId'],
  },
  {
    $type: ACTIONS_TYPES.TriggerbeeWait,
    properties: ['hours', 'minutes', 'seconds'],
  },
  {
    $type: ACTIONS_TYPES.VoyadoAddEmailToList,
    properties: ['source', 'storeExternalId', 'isRunningInRealTime'],
  },
  {
    $type: ACTIONS_TYPES.VoyadoRegisterCart,
    properties: ['language'],
  },
  {
    $type: ACTIONS_TYPES.VoyadoTrigger,
    properties: ['triggerId'],
  },
  {
    $type: ACTIONS_TYPES.VoyadoUpdateConsentPreferences,
    properties: ['acceptsEmail', 'acceptsSms', 'acceptsPostal'],
  },
  {
    $type: ACTIONS_TYPES.VoyadoUpdateMergeTag,
    properties: ['fieldName', 'fieldValue'],
  },
  {
    $type: ACTIONS_TYPES.ZapierTriggerZap,
    properties: ['subscriptionId'],
  },
];

export enum PROPS_TYPE {
  FieldName = 'fieldName',
  FieldValue = 'fieldValue',
  ListId = 'listId',
  ListIds = 'listIds',
  Lists = 'lists',
  TagId = 'tagId',
  TagIds = 'tagIds',
  Tags = 'tags',
  Type = 'type',
  Source = 'source',
}

export const ActionUpdateField = [
  ACTIONS_TYPES.ApsisOneUpdateField,
  ACTIONS_TYPES.ApsisUpdateMergeTag,
  ACTIONS_TYPES.BrevoUpdateContact,
  ACTIONS_TYPES.CleverReachUpdateContact,
  ACTIONS_TYPES.CustobarUpdateField,
  ACTIONS_TYPES.DotdigitalUpdateContact,
  ACTIONS_TYPES.EmarsysUpdateField,
  ACTIONS_TYPES.KlaviyoUpdateField,
  ACTIONS_TYPES.MailchimpUpdateMergeTag,
  ACTIONS_TYPES.MailerLiteUpdateField,
  ACTIONS_TYPES.OmnisendUpdateContact,
  ACTIONS_TYPES.PipedriveUpdateDeal,
  ACTIONS_TYPES.RuleMailerUpdateMergeTag,
  ACTIONS_TYPES.VoyadoUpdateMergeTag,
];

export const ActionListField = [
  ACTIONS_TYPES.ApsisAddEmailToList,
  ACTIONS_TYPES.MailchimpAddEmailToList,
  ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
];

export const ActionUpdateTags = [
  ACTIONS_TYPES.CustobarAddTagsToSubscriber,
  ACTIONS_TYPES.CustobarRemoveTagsFromSubscriber,
  ACTIONS_TYPES.MailchimpAddTagsToSubscriber,
  ACTIONS_TYPES.MailchimpRemoveTagsFromSubscriber,
];

export const AppWithFieldWithoutList = [
  'Voyado',
  'Pipedrive',
  'MailerLite',
  'Klaviyo',
  'Emarsys',
  'ApsisOne',
  'Omnisend',
];

export const ActionWithDefaultCondition = [
  ACTIONS_TYPES.ApsisAddEmailToList,
  ACTIONS_TYPES.ApsisOneCreateSubscriber,
  ACTIONS_TYPES.ApsisOneCreateSubscriber,
  ACTIONS_TYPES.ApsisOneUpdateField,
  ACTIONS_TYPES.ApsisSendMail,
  ACTIONS_TYPES.ApsisUpdateMergeTag,
  ACTIONS_TYPES.BrevoCreateContact,
  ACTIONS_TYPES.BrevoUpdateContact,
  ACTIONS_TYPES.CleverReachCreateContact,
  ACTIONS_TYPES.CleverReachUpdateContact,
  ACTIONS_TYPES.CustobarAddEmailToList,
  ACTIONS_TYPES.CustobarAddTagsToSubscriber,
  ACTIONS_TYPES.CustobarRemoveTagsFromSubscriber,
  ACTIONS_TYPES.CustobarUpdateField,
  ACTIONS_TYPES.DotdigitalCreateContact,
  ACTIONS_TYPES.DotdigitalUpdateContact,
  ACTIONS_TYPES.EmarsysAddEmailToList,
  ACTIONS_TYPES.EmarsysTrigger,
  ACTIONS_TYPES.EmarsysUpdateField,
  ACTIONS_TYPES.KlaviyoAddEmailToList,
  ACTIONS_TYPES.KlaviyoUpdateField,
  ACTIONS_TYPES.MailchimpAddEmailToList,
  ACTIONS_TYPES.MailchimpAddTagsToSubscriber,
  ACTIONS_TYPES.MailchimpRemoveTagsFromSubscriber,
  ACTIONS_TYPES.MailchimpUpdateMergeTag,
  ACTIONS_TYPES.MailerLiteAddEmailToList,
  ACTIONS_TYPES.MailerLiteUpdateField,
  ACTIONS_TYPES.MailerSendSendEmail,
  ACTIONS_TYPES.OmnisendCreateContact,
  ACTIONS_TYPES.OmnisendUpdateContact,
  ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
  ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber,
  ACTIONS_TYPES.RuleMailerUpdateMergeTag,
  ACTIONS_TYPES.TriggerbeeCartAbandonment,
  ACTIONS_TYPES.TriggerbeeTransactionEmail,
  ACTIONS_TYPES.VoyadoAddEmailToList,
  ACTIONS_TYPES.VoyadoRegisterCart,
  ACTIONS_TYPES.VoyadoTrigger,
  ACTIONS_TYPES.VoyadoUpdateConsentPreferences,
  ACTIONS_TYPES.VoyadoUpdateMergeTag,
];

export const TriggerbeeActions = [
  ACTIONS_TYPES.TriggerbeeAddTag,
  ACTIONS_TYPES.TriggerbeeCartAbandonment,
  ACTIONS_TYPES.TriggerbeeExecuteWebhook,
  ACTIONS_TYPES.TriggerbeeRemoveTag,
  ACTIONS_TYPES.TriggerbeeSendMail,
  ACTIONS_TYPES.TriggerbeeTransactionEmail,
  ACTIONS_TYPES.TriggerbeeWait,
];

export const TriggerbeeTagActions = [ACTIONS_TYPES.TriggerbeeAddTag, ACTIONS_TYPES.TriggerbeeRemoveTag];

export const ActionWithWait = [ACTIONS_TYPES.TriggerbeeWait, ACTIONS_TYPES.TriggerbeeCartAbandonment];

export const ActionsPropertiesDetails = {
  [ACTIONS_TYPES.MailchimpAddEmailToList]: {
    $type: ACTIONS_TYPES.MailchimpAddEmailToList,
    translationKey: 'AddEmailToList',
    nameAction: 'Mailchimp',
    properties: [
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Mailchimp/lists',
        translationKey: 'list-in',
        required: true,
        requiredInFormSettings: true,
      },
      {
        name: 'enableDoubleOptIn',
        typeInput: TypeInput.Switch,
        url: '',
        translationKey: 'optin',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.MailchimpAddTagsToSubscriber]: {
    $type: ACTIONS_TYPES.MailchimpAddTagsToSubscriber,
    nameAction: 'Mailchimp',
    translationKey: 'AddTagsToSubscriber',
    requiredList: true,
    listId: '',
    properties: [
      //property listId was removed
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Mailchimp/lists',
        translationKey: 'list-in',
        required: true,
      },
      {
        name: 'tags',
        typeInput: TypeInput.Text,
        url: '',
        translationKey: 'add-tag',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.MailchimpRemoveTagsFromSubscriber]: {
    $type: ACTIONS_TYPES.MailchimpRemoveTagsFromSubscriber,
    nameAction: 'Mailchimp',
    translationKey: 'RemoveTagsFromSubscriber',
    requiredList: true,
    listId: '',
    properties: [
      // property listId was removed
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Mailchimp/lists',
        translationKey: 'list-in',
        required: true,
      },
      {
        name: 'tags',
        typeInput: TypeInput.Text,
        url: '',
        translationKey: 'remove-tag',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.MailchimpUpdateMergeTag]: {
    $type: ACTIONS_TYPES.MailchimpUpdateMergeTag,
    nameAction: 'Mailchimp',
    translationKey: 'UpdateSubscriberField',
    requiredList: true,
    listId: '',
    properties: [
      //property listId was removed
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Mailchimp/lists',
        translationKey: 'list-in',
        description: 'Choose the list',
        required: true,
      },
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: 'FieldValue',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Mailchimp/fields',
        translationKey: 'field',
        description: 'Choose the field',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.VoyadoAddEmailToList]: {
    $type: ACTIONS_TYPES.VoyadoAddEmailToList,
    nameAction: 'Voyado',
    translationKey: 'AddContact',
    properties: [
      {
        name: 'isRunningInRealTime',
        typeInput: TypeInput.Switch,
        translationKey: 'isRunningInRealTime',
      },
      {
        name: 'source',
        typeInput: TypeInput.Text,
        url: null,
        translationKey: 'source',
        required: true,
        defaultValue: 'Triggerbee',
      },
      {
        name: 'storeExternalId',
        typeInput: TypeInput.Text,
        url: null,
        translationKey: 'externalStoreId',
      },
    ],
  },
  [ACTIONS_TYPES.VoyadoTrigger]: {
    $type: ACTIONS_TYPES.VoyadoTrigger,
    nameAction: 'Voyado',
    translationKey: 'TriggerAutomation',
    properties: [
      {
        name: 'triggerId',
        typeInput: TypeInput.List,
        url: '/Voyado/automations',
        translationKey: 'automation',
        description: 'Trigger an automation like sending an email or SMS',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.VoyadoRegisterCart]: {
    $type: ACTIONS_TYPES.VoyadoRegisterCart,
    nameAction: 'Voyado',
    translationKey: 'RegisterCart',
    properties: [
      {
        name: 'language',
        typeInput: TypeInput.List,
        url: '/Voyado/languages',
        translationKey: 'language',
        description: 'Read guidelines for setting up this automation',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.VoyadoUpdateConsentPreferences]: {
    $type: ACTIONS_TYPES.VoyadoUpdateConsentPreferences,
    nameAction: 'Voyado',
    translationKey: 'UpdateConsentPreferences',
    properties: [
      {
        name: 'acceptsEmail',
        typeInput: TypeInput.List,
        url: '/Voyado/consent-preferences',
        translationKey: 'acceptsEmail',
        description: '',
        required: false,
      },
      {
        name: 'acceptsSms',
        typeInput: TypeInput.List,
        url: '/Voyado/consent-preferences',
        translationKey: 'acceptsSms',
        description: '',
        required: false,
      },
      {
        name: 'acceptsPostal',
        typeInput: TypeInput.List,
        url: '/Voyado/consent-preferences',
        translationKey: 'acceptsPostal',
        description: '',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.VoyadoUpdateMergeTag]: {
    $type: ACTIONS_TYPES.VoyadoUpdateMergeTag,
    nameAction: 'Voyado',
    translationKey: 'UpdateFieldOnContact',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Voyado/fields',
        translationKey: 'field-in-app',
        description: '',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.RuleMailerAddTagToSubscriber]: {
    $type: ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
    nameAction: 'Rule',
    translationKey: 'AddTagsToSubscriberRule',
    updatedAction: ACTIONS_TYPES_REAL_TIME.RuleUpdateSubscriberTags,
    properties: [
      {
        name: 'isRunningInRealTime',
        typeInput: TypeInput.Switch,
        translationKey: 'isRunningInRealTime',
      },
      {
        name: 'tagIds',
        typeInput: TypeInput.ListMultiSelect,
        url: '/RuleMailer/lists',
        translationKey: 'tags-in',
        description: '',
        required: true,
        requiredInFormSettings: true,
        addEmptyOption: true,
      },
      {
        name: 'language',
        typeInput: TypeInput.Text,
        url: null,
        translationKey: 'language',
        placeholder: 'language-placeholder',
        description: '',
        required: false,
        additionalInfoKey: 'languageDescription',
      },
      {
        name: 'forceSubscribing',
        typeInput: TypeInput.Switch,
        url: null,
        translationKey: 'add-even-person',
        description: '',
        required: false,
      },
      {
        name: 'doubleOptIn',
        typeInput: TypeInput.Switch,
        url: null,
        translationKey: 'optin',
        required: false,
        $type: ACTIONS_TYPES.RuleMailerAddTagToSubscriber,
        additionalInfoKey: 'optinDescription',
      },
      {
        name: 'resetAutomation',
        typeInput: TypeInput.Switch,
        url: null,
        description: '',
        translationKey: 'reset-contact',
        required: false,
        additionalInfoKey: 'resetAutomationDescription',
      },
    ],
  },
  [ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber]: {
    $type: ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber,
    nameAction: 'Rule',
    translationKey: 'RemoveTagFromSubscriber',
    properties: [
      {
        name: 'tagId',
        typeInput: TypeInput.List,
        url: '/RuleMailer/tags',
        translationKey: 'tagId',
        description: '',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.RuleMailerUpdateMergeTag]: {
    $type: ACTIONS_TYPES.RuleMailerUpdateMergeTag,
    nameAction: 'Rule',
    translationKey: 'UpdateSubscriberField',
    requiredList: true,
    properties: [
      {
        name: 'tagIds',
        typeInput: TypeInput.ListMultiSelect,
        url: '/RuleMailer/lists',
        translationKey: 'tags-in',
        description: '',
        // required: true,
        addEmptyOption: true,
      },
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/RuleMailer/fields',
        translationKey: 'member-field',
        description: '',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.BrevoCreateContact]: {
    $type: ACTIONS_TYPES.BrevoCreateContact,
    nameAction: 'Brevo',
    translationKey: 'AddContactToListBrevo',
    properties: [
      {
        name: 'listIds',
        typeInput: TypeInput.ListMultiSelect,
        url: '/Brevo/lists',
        translationKey: 'lists-in',
        description: '',
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.BrevoUpdateContact]: {
    $type: ACTIONS_TYPES.BrevoUpdateContact,
    nameAction: 'Brevo',
    translationKey: 'UpdateContactAttribute',
    adminRealTimeToggle: true,
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Brevo/fields',
        translationKey: 'member-field',
        description: '',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.DotdigitalCreateContact]: {
    $type: ACTIONS_TYPES.DotdigitalCreateContact,
    nameAction: 'Dotdigital',
    translationKey: 'AddContactToListDotdigital',
    properties: [
      {
        name: 'lists',
        typeInput: TypeInput.ListMultiSelect,
        url: '/Dotdigital/lists',
        translationKey: 'lists-in',
        description: '',
        addEmptyOption: true,
      },
      {
        name: 'updateIfExists',
        typeInput: TypeInput.Switch,
        url: null,
        translationKey: 'updateIfExists',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.DotdigitalUpdateContact]: {
    $type: ACTIONS_TYPES.DotdigitalUpdateContact,
    nameAction: 'Dotdigital',
    translationKey: 'UpdateContactAttribute',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Dotdigital/fields',
        translationKey: 'member-field',
        description: '',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.CleverReachCreateContact]: {
    $type: ACTIONS_TYPES.CleverReachCreateContact,
    nameAction: 'CleverReach',
    translationKey: 'AddContactToGroupCleverReach',
    properties: [],
  },
  [ACTIONS_TYPES.CleverReachUpdateContact]: {
    $type: ACTIONS_TYPES.CleverReachUpdateContact,
    nameAction: 'CleverReach',
    translationKey: 'UpdateContactAttribute',
    adminRealTimeToggle: true,
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/CleverReach/fields',
        translationKey: 'member-field',
        description: '',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.OmnisendCreateContact]: {
    $type: ACTIONS_TYPES.OmnisendCreateContact,
    nameAction: 'Omnisend',
    translationKey: 'AddContactOmnisend',
    properties: [
      {
        name: 'tags',
        typeInput: TypeInput.ListMultiSelect,
        url: '/Omnisend/lists',
        translationKey: 'tags-in',
        description: '',
        required: false,
        requiredInFormSettings: true,
        addEmptyOption: true,
      },
      {
        name: 'updateIfExists',
        typeInput: TypeInput.Switch,
        url: null,
        translationKey: 'updateIfExists',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.OmnisendUpdateContact]: {
    $type: ACTIONS_TYPES.OmnisendUpdateContact,
    nameAction: 'Omnisend',
    translationKey: 'UpdateContactAttribute',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Omnisend/fields',
        translationKey: 'member-field',
        description: '',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.RuleUpdateSubscriberTags]: {
    $type: ACTIONS_TYPES.RuleUpdateSubscriberTags,
    nameAction: 'Rule',
    translationKey: 'RuleUpdateSubscriberTags',
    readOnly: true,
    properties: [
      {
        name: 'isRunningInRealTime',
      },
    ],
  },
  [ACTIONS_TYPES.ZapierTriggerZap]: {
    $type: ACTIONS_TYPES.ZapierTriggerZap,
    nameAction: 'Zapier',
    translationKey: 'SendToZapier',
    properties: [
      {
        name: 'subscriptionId',
        typeInput: TypeInput.List,
        url: '/zapier/zaps',
        translationKey: 'list-in',
        description: 'Select the Zap that you wish to trigger',
        required: true,
        requiredInFormSettings: true,
      },
    ],
  },
  [ACTIONS_TYPES.PipedriveCreateDeal]: {
    $type: ACTIONS_TYPES.PipedriveCreateDeal,
    nameAction: 'Pipedrive',
    translationKey: 'CreateDeal',
    properties: [
      {
        name: 'insertIfNoMatch',
        typeInput: TypeInput.Switch,
        url: '',
        translationKey: 'insert',
        description: '',
        required: false,
      },
      {
        name: 'userId',
        typeInput: TypeInput.List,
        url: '/crm/pipedrive/users',
        translationKey: 'owner',
        description: '',
        required: true,
      },
      {
        name: 'dealStatus',
        typeInput: TypeInput.List,
        url: '/crm/pipedrive/deal-statuses',
        translationKey: 'status',
        description: '',
        required: true,
      },
      {
        name: 'pipelineAndStagingIds',
        typeInput: TypeInput.List,
        url: '/crm/pipedrive/stages',
        translationKey: 'pipeline',
        description: '',
        required: true,
      },
      {
        name: 'dealValue',
        typeInput: TypeInput.Number,
        url: '',
        translationKey: 'dealValue',
        description: '',
        required: true,
      },
      {
        name: 'noteContent',
        typeInput: TypeInput.TextArea,
        url: '',
        translationKey: 'note',
        description: '',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.PipedriveCreateNote]: {
    $type: ACTIONS_TYPES.PipedriveCreateNote,
    nameAction: 'Pipedrive',
    translationKey: 'AddNote',
    properties: [
      {
        name: 'insertIfNoMatch',
        typeInput: TypeInput.Switch,
        url: '',
        translationKey: 'insert',
        description: '',
        required: false,
      },
      {
        name: 'userId',
        typeInput: TypeInput.List,
        url: '/crm/pipedrive/users',
        translationKey: 'owner',
        description: '',
        required: true,
      },
      {
        name: 'noteContent',
        typeInput: TypeInput.TextArea,
        url: '',
        translationKey: 'owner',
        description: '',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.PipedriveCreateOrUpdatePersonOrganization]: {
    $type: ACTIONS_TYPES.PipedriveCreateOrUpdatePersonOrganization,
    nameAction: 'Pipedrive',
    translationKey: 'CreateOrUpdatePersonOrganization',
    properties: [
      {
        name: 'insertIfNoMatch',
        typeInput: TypeInput.Switch,
        url: '',
        translationKey: 'insert',
        description: '',
        required: false,
      },
      {
        name: 'userId',
        typeInput: TypeInput.List,
        url: '/crm/pipedrive/users',
        translationKey: 'owner',
        description: '',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.PipedriveUpdateDeal]: {
    $type: ACTIONS_TYPES.PipedriveUpdateDeal,
    nameAction: 'Pipedrive',
    translationKey: 'SetPropertyOnDeal',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/crm/pipedrive/deal-fields',
        translationKey: 'pipedrive',
        description: 'Choose the property',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.MailerSendSendEmail]: {
    $type: ACTIONS_TYPES.MailerSendSendEmail,
    nameAction: 'MailerSend',
    translationKey: 'SendMail',
    properties: [
      {
        name: 'templateId',
        typeInput: TypeInput.List,
        url: '/MailerSend/templates',
        translationKey: 'template',
        description: '',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.MailerLiteAddEmailToList]: {
    $type: ACTIONS_TYPES.MailerLiteAddEmailToList,
    nameAction: 'MailerLite',
    translationKey: 'AddEmailToList',
    properties: [
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/MailerLite/lists',
        translationKey: 'list-in',
        description: 'Choose the list',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.MailerLiteUpdateField]: {
    $type: ACTIONS_TYPES.MailerLiteUpdateField,
    nameAction: 'MailerLite',
    translationKey: 'UpdateField',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: 'Value',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/MailerLite/fields',
        translationKey: 'field',
        description: 'Choose the field',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.KlaviyoAddEmailToList]: {
    $type: ACTIONS_TYPES.KlaviyoAddEmailToList,
    nameAction: 'Klaviyo',
    translationKey: 'AddEmailToList',
    updatedAction: ACTIONS_TYPES_REAL_TIME.KlaviyoUpdateSubscriberLists,
    properties: [
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Klaviyo/lists',
        translationKey: 'list-in',
        description: 'Choose the list',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.KlaviyoUpdateField]: {
    $type: ACTIONS_TYPES.KlaviyoUpdateField,
    nameAction: 'Klaviyo',
    translationKey: 'UpdateField',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: '',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Klaviyo/fields',
        translationKey: 'field',
        description: 'Choose the field',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.KlaviyoUpdateSubscriberLists]: {
    $type: ACTIONS_TYPES.KlaviyoUpdateSubscriberLists,
    nameAction: 'Klaviyo',
    translationKey: 'KlaviyoUpdateSubscriberLists',
    readOnly: true,
    properties: [
      {
        name: 'isRunningInRealTime',
      },
    ],
  },
  [ACTIONS_TYPES.EmarsysUpdateField]: {
    $type: ACTIONS_TYPES.EmarsysUpdateField,
    nameAction: 'Emarsys',
    translationKey: 'UpdateField',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Emarsys/fields',
        description: 'Choose the field',
        translationKey: 'field',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.EmarsysTrigger]: {
    $type: ACTIONS_TYPES.EmarsysTrigger,
    nameAction: 'Emarsys',
    translationKey: 'TriggerAutomation',
    properties: [
      {
        name: 'eventId',
        typeInput: TypeInput.List,
        url: '/Emarsys/automations',
        translationKey: 'eventId',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.EmarsysAddEmailToList]: {
    $type: ACTIONS_TYPES.EmarsysAddEmailToList,
    nameAction: 'Emarsys',
    translationKey: 'AddEmailToList',
    properties: [
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Emarsys/lists',
        translationKey: 'list-in',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.CustobarAddEmailToList]: {
    translationKey: 'AddEmailToList',
    $type: ACTIONS_TYPES.CustobarAddEmailToList,
    nameAction: 'Custobar',
    updatedAction: ACTIONS_TYPES_REAL_TIME.CustobarUpdateSubscriberLists,
    properties: [
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Custobar/lists',
        translationKey: 'list-in',
        required: true,
        additionalInfoKey: 'waitActionDescription',
      },
    ],
  },
  [ACTIONS_TYPES.CustobarAddTagsToSubscriber]: {
    translationKey: 'AddTagsToSubscriber',
    $type: ACTIONS_TYPES.CustobarAddTagsToSubscriber,
    nameAction: 'Custobar',
    properties: [
      {
        name: 'tags',
        typeInput: TypeInput.Text,
        url: '',
        translationKey: 'add-tag',
        required: true,
        additionalInfoKey: 'waitActionDescription',
      },
    ],
  },
  [ACTIONS_TYPES.CustobarRemoveTagsFromSubscriber]: {
    nameAction: 'Custobar',
    translationKey: 'RemoveTagsFromSubscriber',
    $type: ACTIONS_TYPES.CustobarRemoveTagsFromSubscriber,
    properties: [
      {
        name: 'tags',
        typeInput: TypeInput.Text,
        url: '',
        translationKey: 'remove-tag',
        required: true,
        additionalInfoKey: 'waitActionDescription',
      },
    ],
  },
  [ACTIONS_TYPES.CustobarUpdateField]: {
    $type: ACTIONS_TYPES.CustobarUpdateField,
    nameAction: 'Custobar',
    translationKey: 'UpdateField',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: 'Choose value',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Custobar/fields',
        translationKey: 'field',
        description: 'Choose the field',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.CustobarTrigger]: {
    $type: ACTIONS_TYPES.CustobarTrigger,
    nameAction: 'Custobar',
    translationKey: 'TriggerAutomation',
    properties: [
      {
        name: 'eventName',
        typeInput: TypeInput.List,
        url: '/Custobar/automations',
        translationKey: 'automation',
        description: 'Trigger an automation in Custobar by sending a custom event',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.CustobarUpdateSubscriberLists]: {
    $type: ACTIONS_TYPES.CustobarUpdateSubscriberLists,
    nameAction: 'Custobar',
    translationKey: 'CustobarUpdateSubscriberLists',
    readOnly: true,
    properties: [
      {
        name: 'isRunningInRealTime',
      },
    ],
  },
  [ACTIONS_TYPES.CustomSendWebhook]: {
    $type: ACTIONS_TYPES.CustomSendWebhook,
    nameAction: 'Custom',
    translationKey: 'CustomSendWebhook',
    docsUrl: 'https://help.triggerbee.com/en/articles/15250619-custom-integration',
    properties: [
      {
        name: 'webhookUrl',
        typeInput: TypeInput.Text,
        translationKey: 'webhookUrl',
        additionalUnderInfoKey: 'webhookUrlHint',
        required: true,
        requiredInFormSettings: true,
        isUrl: true,
      },
      {
        name: 'webhookHttpMethod',
        typeInput: TypeInput.List,
        translationKey: 'webhookHttpMethod',
        required: false,
        defaultValue: 'Post',
        // Static options. Value = PascalCase to match nameof(HttpMethod.X) on the server; label = uppercase per HTTP convention.
        listUI: [
          { id: 'Post', name: 'POST' },
          { id: 'Get', name: 'GET' },
          { id: 'Put', name: 'PUT' },
          { id: 'Patch', name: 'PATCH' },
          { id: 'Delete', name: 'DELETE' },
        ],
      },
      {
        name: 'webhookFieldMappings',
        typeInput: TypeInput.FieldMappingDictionary,
        translationKey: 'webhookFieldMappings',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.ApsisAddEmailToList]: {
    $type: ACTIONS_TYPES.ApsisAddEmailToList,
    nameAction: 'Apsis',
    translationKey: 'AddEmailToList',
    properties: [
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Apsis/lists',
        translationKey: 'list-in',
        description: 'Choose the list',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.ApsisSendMail]: {
    $type: ACTIONS_TYPES.ApsisSendMail,
    nameAction: 'Apsis',
    translationKey: 'SendMail',
    properties: [
      {
        name: 'projectId',
        typeInput: TypeInput.List,
        url: '/Apsis/templates',
        translationKey: 'template',
        description: 'Choose the template',
        required: false,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.ApsisUpdateMergeTag]: {
    $type: ACTIONS_TYPES.ApsisUpdateMergeTag,
    nameAction: 'Apsis',
    translationKey: 'UpdateSubscriberField',
    requiredList: true,
    properties: [
      //property listId was removed
      {
        name: 'listId',
        typeInput: TypeInput.List,
        url: '/Apsis/lists',
        translationKey: 'list-in',
        description: 'Choose the list',
        required: true,
      },
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/Apsis/fields',
        translationKey: 'field',
        description: 'Choose the field',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.ApsisOneCreateSubscriber]: {
    $type: ACTIONS_TYPES.ApsisOneCreateSubscriber,
    nameAction: 'ApsisOne',
    translationKey: 'AddEmailToList',
    properties: [
      {
        typeInput: TypeInput.Description,
        translationKey: 'description',
      },
    ],
  },
  [ACTIONS_TYPES.ApsisOneUpdateField]: {
    $type: ACTIONS_TYPES.ApsisOneUpdateField,
    nameAction: 'ApsisOne',
    translationKey: 'UpdateSubscriberField',
    properties: [
      {
        name: 'fieldValue',
        typeInput: TypeInput.ListSelect,
        url: '',
        translationKey: 'property-in-Triggerbee',
        description: 'FieldValue',
        required: true,
      },
      {
        name: 'fieldName',
        typeInput: TypeInput.List,
        url: '/ApsisOne/fields',
        translationKey: 'field',
        description: 'Choose the field',
        required: true,
        addEmptyOption: true,
      },
    ],
  },
  [ACTIONS_TYPES.ApsisOneAddToSubscription]: {
    $type: ACTIONS_TYPES.ApsisOneAddToSubscription,
    nameAction: 'ApsisOne',
    translationKey: 'ApsisOneAddToSubscription',
    properties: [
      {
        name: 'channelDiscriminator',
        typeInput: TypeInput.List,
        url: '/ApsisOne/channels',
        translationKey: 'channel',
        description: '',
        required: true,
        requiredInFormSettings: true,
        addEmptyOption: true,
      },
      {
        name: 'topicDiscriminator',
        typeInput: TypeInput.List,
        url: '/ApsisOne/lists',
        translationKey: 'topic',
        description: '',
        required: true,
        requiredInFormSettings: true,
        addEmptyOption: true,
      },
      {
        name: 'type',
        typeInput: TypeInput.List,
        url: '',
        translationKey: 'type',
        description: '',
        required: true,
        requiredInFormSettings: true,
        addEmptyOption: true,
      },
      {
        name: 'reason',
        typeInput: TypeInput.Text,
        url: '',
        translationKey: 'reason',
        description: '',
        required: true,
        requiredInFormSettings: true,
      },
      {
        name: 'source',
        typeInput: TypeInput.Text,
        url: '',
        translationKey: 'source',
        description: '',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.TriggerbeeAddTag]: {
    $type: ACTIONS_TYPES.TriggerbeeAddTag,
    nameAction: 'Triggerbee',
    translationKey: 'AddTag',
    properties: [
      {
        name: 'tag',
        typeInput: TypeInput.List,
        url: '/tags',
        translationKey: 'tagName',
        description: '',
        required: true,
        requiredInFormSettings: true,
        addEmptyOption: true,
      },
      {
        name: 'addToProfile',
        typeInput: TypeInput.Switch,
        url: '',
        translationKey: 'addToProfile',
        description: '',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.TriggerbeeCartAbandonment]: {
    $type: ACTIONS_TYPES.TriggerbeeCartAbandonment,
    nameAction: 'Triggerbee',
    translationKey: 'CartAbandonment',
    properties: [
      {
        name: 'minutes',
        typeInput: TypeInput.Number,
        url: '',
        translationKey: 'minutes',
        required: true,
        additionalUnderInfoKey: 'description',
        defaultValue: 60,
      },
      {
        name: 'cartGoalArgument',
        typeInput: TypeInput.List,
        url: '/goals',
        translationKey: 'goalCompleted',
        description: '',
        required: true,
      },
      {
        name: 'purchaseGoalArgument',
        typeInput: TypeInput.List,
        url: '/goals',
        translationKey: 'goalNotCompleted',
        description: '',
        required: true,
      },
    ],
  },
  [ACTIONS_TYPES.TriggerbeeExecuteWebhook]: {
    $type: ACTIONS_TYPES.TriggerbeeExecuteWebhook,
    nameAction: 'Triggerbee',
    translationKey: 'ExecuteWebhook',
    properties: [
      {
        name: 'url',
        typeInput: TypeInput.Text,
        url: '',
        translationKey: 'url',
        description:
          'Enter the URL to your webhook receiver. The payload will contain data about the visit. Read more here',
        required: true,
        requiredInFormSettings: true,
      },
      {
        name: 'useNewPayloadFormat',
        typeInput: TypeInput.Switch,
        url: '',
        translationKey: 'useNewPayloadFormat',
        description: 'useNewPayloadFormat',
        required: false,
        defaultValue: true,
      },
    ],
  },
  [ACTIONS_TYPES.TriggerbeeRemoveTag]: {
    $type: ACTIONS_TYPES.TriggerbeeRemoveTag,
    nameAction: 'Triggerbee',
    translationKey: 'RemoveTag',
    properties: [
      {
        name: 'tag',
        typeInput: TypeInput.List,
        url: '/tags',
        translationKey: 'tagName',
        description: '',
        required: true,
        requiredInFormSettings: true,
        addEmptyOption: true,
      },
      {
        name: 'removeFromProfile',
        typeInput: TypeInput.Switch,
        url: '',
        translationKey: 'removeFromProfile',
        description: '',
        required: false,
      },
    ],
  },
  [ACTIONS_TYPES.TriggerbeeSendMail]: {
    $type: ACTIONS_TYPES.TriggerbeeSendMail,
    nameAction: 'Triggerbee',
    translationKey: 'Mail',
    properties: [
      {
        name: 'recipients',
        typeInput: TypeInput.ListMultiSelect,
        translationKey: 'recipients',
        required: true,
        requiredInFormSettings: true,
      },
      {
        name: 'replyTo',
        typeInput: TypeInput.Text,
        translationKey: 'replyto',
        required: false,
        additionalInfoKey: 'replytoDescription',
      },
      {
        name: 'subject',
        typeInput: TypeInput.Text,
        translationKey: 'subject',
        description: 'Subject',
        required: true,
        requiredInFormSettings: true,
      },
      {
        name: 'message',
        typeInput: TypeInput.TextArea,
        translationKey: 'message',
        description: 'message',
        required: true,
        requiredInFormSettings: true,
      },
    ],
  },
  [ACTIONS_TYPES.TriggerbeeTransactionEmail]: {
    $type: ACTIONS_TYPES.TriggerbeeTransactionEmail,
    nameAction: 'Triggerbee',
    translationKey: 'TransactionalEmail',
    isBeta: true,
    properties: [
      {
        name: 'templateId',
        typeInput: TypeInput.List,
        translationKey: 'templateId',
        required: true,
        requiredInFormSettings: true,
      },
    ],
  },
  [ACTIONS_TYPES.TriggerbeeWait]: {
    $type: ACTIONS_TYPES.TriggerbeeWait,
    nameAction: 'Triggerbee',
    translationKey: 'Wait',
    properties: [
      {
        name: 'hours',
        typeInput: TypeInput.Number,
        translationKey: 'hours',
        description: 'hours',
        additionalUnderInfoKey: 'description',
        required: true,
        defaultValue: 0,
      },
      {
        name: 'minutes',
        typeInput: TypeInput.Number,
        translationKey: 'minutes',
        description: 'minutes',
        required: true,
        defaultValue: 5,
      },
    ],
  },
  [ACTIONS_TYPES.CentraCreateMember]: {
    $type: ACTIONS_TYPES.CentraCreateMember,
    nameAction: 'Centra',
    translationKey: 'CentraCreateMember',
    readOnly: true,
    properties: [
      {
        name: 'isRunningInRealTime',
      },
    ],
  },
  [ACTIONS_TYPES.ShopifyCreateMember]: {
    $type: ACTIONS_TYPES.ShopifyCreateMember,
    nameAction: 'Shopify',
    translationKey: 'ShopifyCreateMember',
    readOnly: true,
    properties: [
      {
        name: 'isRunningInRealTime',
      },
    ],
  },
  [ACTIONS_TYPES.ShopwareCreateMember]: {
    $type: ACTIONS_TYPES.ShopwareCreateMember,
    nameAction: 'Shopware',
    translationKey: 'ShopwareCreateMember',
    readOnly: false,
    properties: [
      {
        name: 'salesChannelId',
        typeInput: TypeInput.List,
        url: '/Shopware/lists',
        translationKey: 'salesChannelId',
        required: true,
        requiredInFormSettings: true,
      },
      {
        name: 'groupId',
        typeInput: TypeInput.List,
        url: '/Shopware/segments',
        translationKey: 'groupId',
        required: true,
        requiredInFormSettings: true,
      },
      {
        name: 'defaultPaymentMethodId',
        typeInput: TypeInput.List,
        url: '/Shopware/payment-methods',
        translationKey: 'defaultPaymentMethodId',
        required: false,
        requiredInFormSettings: false,
      },
      {
        name: 'countryId',
        typeInput: TypeInput.List,
        url: '/Shopware/countries',
        translationKey: 'countryId',
        required: false,
        requiredInFormSettings: false,
      },
    ],
  },
};
export const CONFIG_EDITOR_AUTOMATION = [
  {
    name: 'Voyado',
    iconUrl: '/assets/img/logos/voyado.png',
    expanded: false,
    enabled: false,
    multi: true,
    adminRealTimeToggle: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-contact',
        actionsGroup: [
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoAddEmailToList] },
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoUpdateConsentPreferences] },
        ],
        expanded: false,
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoUpdateMergeTag] }],
        expanded: false,
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoUpdateMergeTag] }],
        expanded: false,
      },
      {
        nameGroup: TypeStep.Trigger,
        translationKey: 'trigger-an-automation',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoTrigger] }],
        expanded: false,
      },
    ],
  },
  {
    name: 'MailChimp',
    iconUrl: '/assets/img/logos/mailchimp_freddie_color_web.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-audience',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpAddEmailToList] }],
        expanded: false,
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        requiredList: true,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpUpdateMergeTag] }],
        expanded: false,
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        requiredList: true,
        expanded: false,
        actionsGroup: [
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpUpdateMergeTag] },
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpAddTagsToSubscriber] },
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpRemoveTagsFromSubscriber] },
        ],
      },
    ],
  },
  {
    name: 'Rule',
    iconUrl: '/assets/img/icons/rule-icon.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-subscriber',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.RuleMailerAddTagToSubscriber] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        requiredList: true,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.RuleMailerUpdateMergeTag] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        requiredList: true,
        expanded: false,
        actionsGroup: [
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.RuleMailerUpdateMergeTag] },
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber] },
        ],
      },
    ],
  },
  {
    name: 'Brevo',
    iconUrl: '/assets/img/logos/brevo.jpg',
    expanded: false,
    enabled: false,
    multi: true,
    adminRealTimeToggle: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-contact',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.BrevoCreateContact] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.BrevoUpdateContact] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        requiredList: true,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.BrevoUpdateContact] }],
      },
    ],
  },
  {
    name: 'Dotdigital',
    iconUrl: '/assets/img/logos/dotdigital.png',
    expanded: false,
    enabled: false,
    multi: true,
    adminRealTimeToggle: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-contact',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.DotdigitalCreateContact] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.DotdigitalUpdateContact] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        requiredList: true,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.DotdigitalUpdateContact] }],
      },
    ],
  },
  {
    name: 'Omnisend',
    iconUrl: '/assets/img/logos/omnisend.png',
    expanded: false,
    enabled: false,
    multi: true,
    adminRealTimeToggle: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-contact',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.OmnisendCreateContact] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.OmnisendUpdateContact] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        requiredList: true,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.OmnisendUpdateContact] }],
      },
    ],
  },
  {
    name: 'CleverReach',
    iconUrl: '/assets/img/logos/cleverreach.svg',
    expanded: false,
    enabled: false,
    multi: true,
    adminRealTimeToggle: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-contact',
        expanded: false,
        additionalInfoKey: 'AddContactToGroupCleverReach.add-contact-info',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.CleverReachCreateContact] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.CleverReachUpdateContact] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.CleverReachUpdateContact] }],
      },
    ],
  },
  {
    name: 'Custobar',
    iconUrl: '/assets/img/logos/custobar.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-list',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.CustobarAddEmailToList] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.CustobarUpdateField] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        additionalInfoKey: 'AddTagsToSubscriber.waitActionDescription',
        actionsGroup: [
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.CustobarUpdateField] },
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.CustobarAddTagsToSubscriber] },
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.CustobarRemoveTagsFromSubscriber] },
        ],
      },
      {
        nameGroup: TypeStep.Trigger,
        translationKey: 'trigger-an-automation',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.CustobarTrigger] }],
      },
    ],
  },
  {
    name: 'Custom',
    iconUrl: '/assets/img/http.svg',
    expanded: false,
    enabled: false,
    multi: false,
    isNew: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.Webhook,
        translationKey: 'send-webhook',
        expanded: false,
        additionalInfoKey: 'CustomSendWebhook.description',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.CustomSendWebhook] }],
      },
    ],
  },
  {
    name: 'Klaviyo',
    iconUrl: '/assets/img/logos/klaviyo.svg',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-list',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.KlaviyoAddEmailToList] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.KlaviyoUpdateField] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.KlaviyoUpdateField] }],
      },
    ],
  },
  {
    name: 'MailerSend',
    iconUrl: '/assets/img/logos/mailer_send.svg',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-list',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.MailerSendSendEmail] }],
      },
    ],
  },
  {
    name: 'MailerLite',
    iconUrl: '/assets/img/logos/mailerlite.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-list',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.MailerLiteAddEmailToList] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.MailerLiteUpdateField] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.MailerLiteUpdateField] }],
      },
    ],
  },
  {
    name: 'Apsis',
    iconUrl: '/assets/img/logos/apsis.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-list',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisAddEmailToList] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        requiredList: true,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisUpdateMergeTag] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        requiredList: true,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisUpdateMergeTag] }],
      },
      {
        nameGroup: TypeStep.SendEmail,
        translationKey: 'send-an-email',
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisSendMail] }],
        expanded: false,
      },
    ],
  },
  {
    name: 'ApsisOne',
    iconUrl: '/assets/img/logos/apsis-one.jpg',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-list',
        expanded: false,
        actionsGroup: [
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisOneCreateSubscriber] },
          { action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisOneAddToSubscription] },
        ],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        requiredList: true,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisOneUpdateField] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        requiredList: true,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ApsisOneUpdateField] }],
      },
    ],
  },
  {
    name: 'Emarsys',
    iconUrl: '/assets/img/logos/emarsys.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-email-to-list',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.EmarsysAddEmailToList] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'field-mapping',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.EmarsysUpdateField] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'update-other-fields',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.EmarsysUpdateField] }],
      },
      {
        nameGroup: TypeStep.Trigger,
        translationKey: 'trigger-an-automation',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.EmarsysTrigger] }],
      },
    ],
  },
  {
    name: 'Zapier',
    iconUrl: '/assets/img/logos/zapier.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.Trigger,
        translationKey: 'trigger-zap',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ZapierTriggerZap] }],
        requiredList: true,
        isZapierTrigger: true,
      },
      {
        nameGroup: TypeStep.ZapierEmbed,
        translationKey: 'zapier-embed-step',
        expanded: false,
        actionsGroup: [],
        requiredList: true,
        isZapierEmbed: true,
      },
    ],
  },
  {
    name: 'Pipedrive',
    iconUrl: '/assets/img/logos/pipedrive-logo-bullet.png',
    expanded: false,
    enabled: false,
    multi: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'create-deal',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveCreateDeal] }],
      },
      {
        nameGroup: TypeStep.FieldMapping,
        translationKey: 'update-deal',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveUpdateDeal] }],
      },
      {
        nameGroup: TypeStep.UpdateOtherFields,
        translationKey: 'create-note',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveCreateNote] }],
      },
      {
        nameGroup: TypeStep.Trigger,
        translationKey: 'create-update-organization',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveCreateOrUpdatePersonOrganization] }],
      },
    ],
  },
  {
    name: 'TriggerbeeExecuteWebhook',
    translationName: 'triggerbee-webhook',
    iconUrl: '/assets/img/logos/webhook-icon.svg',
    expanded: false,
    enabled: false,
    multi: false,
    type: 'step',
    actionsConfig: [
      {
        nameGroup: TypeStep.Webhook,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeExecuteWebhook] }],
      },
    ],
  },
  {
    name: 'TriggerbeeSendMail',
    translationName: 'triggerbee-email',
    iconUrl: '/assets/img/icons/mail.svg',
    expanded: false,
    enabled: false,
    multi: false,
    type: 'step',
    actionsConfig: [
      {
        nameGroup: TypeStep.Email,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeSendMail] }],
      },
    ],
  },
  {
    name: 'TriggerbeeTransactionEmail',
    translationName: 'triggerbee-transactional-email',
    iconUrl: '/assets/img/icons/mail.svg',
    expanded: false,
    enabled: false,
    multi: false,
    type: 'step',
    isBeta: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.Email,
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeTransactionEmail] }],
      },
    ],
  },
  {
    name: 'TriggerbeeProfile',
    translationName: 'triggerbee-profile',
    iconUrl: '/assets/img/icons/person.svg',
    expanded: false,
    enabled: false,
    multi: true,
    type: 'step',
    actionsConfig: [
      {
        nameGroup: TypeStep.TagAdd,
        translationKey: 'add-tag-to-profile',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeAddTag] }],
      },
      {
        nameGroup: TypeStep.TagRemove,
        translationKey: 'remove-tag-from-profile',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeRemoveTag] }],
      },
    ],
  },
  {
    name: 'Shopware',
    iconUrl: '/assets/img/logos/shopware.svg',
    expanded: false,
    enabled: false,
    multi: true,
    adminRealTimeToggle: true,
    actionsConfig: [
      {
        nameGroup: TypeStep.AddContact,
        translationKey: 'add-customer',
        expanded: false,
        actionsGroup: [{ action: ActionsPropertiesDetails[ACTIONS_TYPES.ShopwareCreateMember] }],
      },
    ],
  },
];

export const ActionsListUI = [
  {
    name: 'Voyado',
    submenu: true,
    iconUrl: '/assets/img/logos/voyado.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoAddEmailToList],
      ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoRegisterCart],
      ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoTrigger],
      ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoUpdateConsentPreferences],
      ActionsPropertiesDetails[ACTIONS_TYPES.VoyadoUpdateMergeTag],
    ],
  },
  {
    name: 'Mailchimp',
    submenu: true,
    iconUrl: '/assets/img/logos/mailchimp_freddie_color_web.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpAddEmailToList],
      ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpAddTagsToSubscriber],
      ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpRemoveTagsFromSubscriber],
      ActionsPropertiesDetails[ACTIONS_TYPES.MailchimpUpdateMergeTag],
    ],
  },
  {
    name: 'Rule',
    submenu: true,
    iconUrl: '/assets/img/icons/rule-icon.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.RuleMailerAddTagToSubscriber],
      ActionsPropertiesDetails[ACTIONS_TYPES.RuleMailerRemoveTagFromSubscriber],
      ActionsPropertiesDetails[ACTIONS_TYPES.RuleMailerUpdateMergeTag],
    ],
  },
  {
    name: 'Brevo',
    submenu: true,
    iconUrl: '/assets/img/logos/brevo.jpg',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.BrevoCreateContact],
      ActionsPropertiesDetails[ACTIONS_TYPES.BrevoUpdateContact],
    ],
  },
  {
    name: 'Dotdigital',
    submenu: true,
    iconUrl: '/assets/img/logos/dotdigital.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.DotdigitalCreateContact],
      ActionsPropertiesDetails[ACTIONS_TYPES.DotdigitalUpdateContact],
    ],
  },
  {
    name: 'Omnisend',
    submenu: true,
    iconUrl: '/assets/img/logos/omnisend.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.OmnisendCreateContact],
      ActionsPropertiesDetails[ACTIONS_TYPES.OmnisendUpdateContact],
    ],
  },
  {
    name: 'CleverReach',
    submenu: true,
    iconUrl: '/assets/img/logos/cleverreach.svg',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.CleverReachCreateContact],
      ActionsPropertiesDetails[ACTIONS_TYPES.CleverReachUpdateContact],
    ],
  },
  {
    name: 'Klaviyo',
    submenu: true,
    iconUrl: '/assets/img/logos/klaviyo.svg',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.KlaviyoAddEmailToList],
      ActionsPropertiesDetails[ACTIONS_TYPES.KlaviyoUpdateField],
    ],
  },
  {
    name: 'Zapier',
    submenu: true,
    iconUrl: '/assets/img/logos/zapier.png',
    actions: [ActionsPropertiesDetails[ACTIONS_TYPES.ZapierTriggerZap]],
  },
  {
    name: 'Custobar',
    submenu: true,
    iconUrl: '/assets/img/logos/custobar.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.CustobarAddEmailToList],
      ActionsPropertiesDetails[ACTIONS_TYPES.CustobarAddTagsToSubscriber],
      ActionsPropertiesDetails[ACTIONS_TYPES.CustobarRemoveTagsFromSubscriber],
      ActionsPropertiesDetails[ACTIONS_TYPES.CustobarTrigger],
      ActionsPropertiesDetails[ACTIONS_TYPES.CustobarUpdateField],
    ],
  },
  {
    name: 'Custom',
    submenu: true,
    iconUrl: '/assets/img/logos/webhook-icon.svg',
    isNew: true,
    actions: [ActionsPropertiesDetails[ACTIONS_TYPES.CustomSendWebhook]],
  },
  {
    name: 'MailerLite',
    submenu: true,
    iconUrl: '/assets/img/logos/mailerlite.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.MailerLiteAddEmailToList],
      ActionsPropertiesDetails[ACTIONS_TYPES.MailerLiteUpdateField],
    ],
  },
  {
    name: 'MailerSend',
    submenu: true,
    iconUrl: '/assets/img/logos/mailer_send.svg',
    actions: [ActionsPropertiesDetails[ACTIONS_TYPES.MailerSendSendEmail]],
  },
  {
    name: 'Apsis',
    submenu: true,
    iconUrl: '/assets/img/logos/apsis.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.ApsisAddEmailToList],
      ActionsPropertiesDetails[ACTIONS_TYPES.ApsisSendMail],
      ActionsPropertiesDetails[ACTIONS_TYPES.ApsisUpdateMergeTag],
    ],
  },
  {
    name: 'ApsisOne',
    submenu: true,
    iconUrl: '/assets/img/logos/apsis-one.jpg',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.ApsisOneCreateSubscriber],
      ActionsPropertiesDetails[ACTIONS_TYPES.ApsisOneAddToSubscription],
      ActionsPropertiesDetails[ACTIONS_TYPES.ApsisOneUpdateField],
    ],
  },
  {
    name: 'Emarsys',
    submenu: true,
    iconUrl: '/assets/img/logos/emarsys.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.EmarsysAddEmailToList],
      ActionsPropertiesDetails[ACTIONS_TYPES.EmarsysTrigger],
      ActionsPropertiesDetails[ACTIONS_TYPES.EmarsysUpdateField],
    ],
  },
  {
    name: 'Triggerbee',
    submenu: true,
    iconUrl: '/assets/img/logos/triggerbe-black-bullet.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeAddTag],
      ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeCartAbandonment],
      ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeExecuteWebhook],
      ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeRemoveTag],
      ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeSendMail],
      ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeTransactionEmail],
      ActionsPropertiesDetails[ACTIONS_TYPES.TriggerbeeWait],
    ],
  },
  {
    name: 'Pipedrive',
    submenu: true,
    iconUrl: 'assets/img/logos/pipedrive-logo-bullet.png',
    actions: [
      ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveCreateDeal],
      ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveCreateNote],
      ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveCreateOrUpdatePersonOrganization],
      ActionsPropertiesDetails[ACTIONS_TYPES.PipedriveUpdateDeal],
    ],
  },
  {
    name: 'Shopware',
    submenu: true,
    iconUrl: '/assets/img/logos/shopware.svg',
    actions: [ActionsPropertiesDetails[ACTIONS_TYPES.ShopwareCreateMember]],
  },
];

export const OPERATORS = [
  'Equals',
  'NotEquals',
  'Contains',
  'ContainsAnyOf',
  'DoesNotContainsAnyOf',
  'DoesNotContain',
  'MoreThan',
  'LessThan',
  'IsEmpty',
  'IsNotEmpty',
  'StartsWith',
  'EndsWith',
];

export enum TriggerType {
  Goals = 'Goals',
  WidgetFormSubmission = 'WidgetFormSubmission',
  Url = 'Url',
  Event = 'Event',
}

/** Persisted discriminator within a TriggerType; mirrors the backend EventDefinitionType. */
export enum TriggerSubType {
  CouponDistributed = 'CouponDistributed',
  CouponCopied = 'CouponCopied',
}

export enum TriggerTypeArgument {
  AbandonCart = 'AbandonCart',
  Widget = 'Widget',
  Goal = 'Goal',
  VisitedPage = 'VisitedPage',
  Event = 'Event',
}

export enum TriggerArgument {
  CompletedPurchase = 'Completed purchase',
}

export const TRIGGER_OPERATORS: { [type: string]: string[] } = {
  [TriggerType.Goals]: ['Equals'],
  [TriggerType.WidgetFormSubmission]: ['Equals'],
  [TriggerType.Url]: ['Equals', 'Contains'],
  // One entry in the picker; the chosen event definition decides the subtype, so there is no 'any' case
  [TriggerType.Event]: ['Equals'],
};

/**
 * Triggers that /automations/create can seed from its query string, keyed by the `trigger` parameter.
 * The keys are the ones the picker labels itself with, so a URL names the same thing the dropdown shows.
 * A scoped trigger takes widgetId (and optionally componentId); every other one takes a single argument.
 */
export interface SeedableTrigger {
  type: TriggerType;
  typeArgument: TriggerTypeArgument;
  subType?: TriggerSubType;
  scoped?: boolean;
}

export const SEEDABLE_TRIGGERS: { [trigger: string]: SeedableTrigger } = {
  Goals: { type: TriggerType.Goals, typeArgument: TriggerTypeArgument.Goal },
  AbandonCart: { type: TriggerType.Goals, typeArgument: TriggerTypeArgument.AbandonCart },
  WidgetFormSubmission: { type: TriggerType.WidgetFormSubmission, typeArgument: TriggerTypeArgument.Widget },
  Url: { type: TriggerType.Url, typeArgument: TriggerTypeArgument.VisitedPage },
  CouponDistributed: {
    type: TriggerType.Event,
    typeArgument: TriggerTypeArgument.Event,
    subType: TriggerSubType.CouponDistributed,
    scoped: true,
  },
  CouponCopied: {
    type: TriggerType.Event,
    typeArgument: TriggerTypeArgument.Event,
    subType: TriggerSubType.CouponCopied,
    scoped: true,
  },
};

export const TRIGGERS = [
  {
    argument: null,
    type: TriggerType.Goals,
    typeArgument: TriggerTypeArgument.AbandonCart,
    name: '',
  },
  {
    argument: null,
    type: TriggerType.Goals,
    typeArgument: TriggerTypeArgument.Goal,
    name: '',
  },
  {
    argument: null,
    type: TriggerType.WidgetFormSubmission,
    typeArgument: TriggerTypeArgument.Widget,
    name: '',
  },
  {
    argument: null,
    type: TriggerType.Url,
    typeArgument: TriggerTypeArgument.VisitedPage,
    name: '',
  },
  // One picker entry per subtype, so the choice is made in the list instead of a step later.
  {
    argument: null,
    type: TriggerType.Event,
    typeArgument: TriggerTypeArgument.Event,
    subType: TriggerSubType.CouponDistributed,
    name: '',
  },
  {
    argument: null,
    type: TriggerType.Event,
    typeArgument: TriggerTypeArgument.Event,
    subType: TriggerSubType.CouponCopied,
    name: '',
  },
];

export const CONDITIONS = [
  {
    argument: null,
    type: 'Email',
    typeArgument: null,
    name: '',
  },
  {
    argument: null,
    type: 'AccumulatedEngagement',
    typeArgument: 'Number',
    name: '',
  },
  {
    arguments: null,
    type: 'PreviousVisit',
    typeArgument: 'Number',
    name: '',
  },
  {
    arguments: null,
    type: 'EarlierOrNowGoals',
    typeArgument: 'Goal',
    name: '',
  },
  {
    arguments: null,
    type: 'Tags',
    typeArgument: 'Label',
    name: '',
  },
  {
    arguments: null,
    type: 'Campaign',
    typeArgument: null,
    name: '',
  },
  {
    arguments: null,
    type: 'CountryCode',
    typeArgument: null,
    name: '',
  },
  {
    arguments: null,
    type: 'ActionsCount',
    typeArgument: 'Number',
    name: '',
  },
  {
    argument: null,
    type: 'Phone',
    typeArgument: null,
    name: '',
  },
];
